import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_EquipmentPressureDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
    position: e_Positions;
};

export type t_EquipmentPressureDataset = {
    dataPoints: t_EquipmentPressureDataPoint[];
};

export enum e_Positions {
    Connection_Upper_Undercarriage,
    Undercarriage,
    Main_Uppercarriage,
    Boom_Cylinder,
    Stick_Cylinder,
    Tool,
}

export var initEquipmentCurrentDataset: t_EquipmentPressureDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.PRESSURE.OUTRIGGER',
            dataName: {
                name: 'PressureOutrigger',
            },
            unit: 'bar',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.DRIVE',
            dataName: {
                name: 'PressureDrive',
            },
            unit: 'bar',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.DRIVE_A',
            dataName: {
                name: 'PressureDriveA',
            },
            unit: 'bar',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.DRIVE_B',
            dataName: {
                name: 'PressureDriveB',
            },
            unit: 'bar',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.SLEW',
            dataName: {
                name: 'PressureSlew',
            },
            unit: 'bar',
            position: e_Positions.Connection_Upper_Undercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.STICK_PISTON',
            dataName: {
                name: 'PressureStickPistonSide',
            },
            unit: 'bar',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.PRESSURE.STICK_ROD',
            dataName: {
                name: 'PressureStickRodSide',
            },
            unit: 'bar',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.PRESSURE.BOOM_PISTON',
            dataName: {
                name: 'PressureBoomPistonSide',
            },
            unit: 'bar',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.PRESSURE.BOOM_ROD',
            dataName: {
                name: 'PressureBoomRodSide',
            },
            unit: 'bar',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.PRESSURE.MAIN_PUMP_1',
            dataName: {
                name: 'PressureMainPump1',
            },
            unit: 'bar',
            position: e_Positions.Main_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.MAIN_PUMP_2',
            dataName: {
                name: 'PressureMainPump2',
            },
            unit: 'bar',
            position: e_Positions.Main_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.PRESSURE.TOOL',
            dataName: {
                name: 'PressureToolClose',
            },
            unit: 'bar',
            position: e_Positions.Tool,
        },
    ],
};